export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado de los contenedores"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen del estado de exportación de los contenedores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver detalles"])},
          "agro_exporter_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso"])},
          "total_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "in_preparation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preparando"])},
          "in_transit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viajando"])},
          "arrived": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Llegó"])}
        }
      }
    }
  })
}